import { Badge } from "../common/styles";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RoundProjects = _ref => {
  let {
    roundStates,
    totalApplicationCount,
    approvedApplications
  } = _ref;
  if (roundStates !== null && roundStates !== void 0 && roundStates.includes("accepting-applications")) {
    return /*#__PURE__*/_jsxs(Badge, {
      disabled: totalApplicationCount === 0,
      "data-testid": "applications-count",
      children: [totalApplicationCount, " applications"]
    });
  } else {
    return /*#__PURE__*/_jsxs(Badge, {
      disabled: approvedApplications === 0,
      "data-testid": "approved-applications-count",
      children: [approvedApplications, " projects"]
    });
  }
};